import {Box,Image} from "@chakra-ui/react"
export default function AuthNavbar(){
    return(
            <Box h="100px" bg={'rgb(30,128,253)'}><Image h="90%" display="block" margin="auto" src={"https://64.media.tumblr.com/3cc401364c5c9425bd4eb71c383d5049/95991999c0eacd3a-00/s500x750/e4dbb7cecfc4aa397cffdcce758303e4bbe4d58e.pnj"}/></Box>
            
    )
}